import React from 'react'
import classnames from 'classnames'

export interface IButtonIcon {
  icon: string
  type?: 'primary' | 'secondary' | 'text' | 'remove' | 'alternative'
  size?: 'S' | 'M' | 'L'
  disabled?: boolean
  active?: boolean
  className?: string
  onClick: React.MouseEventHandler<HTMLButtonElement>
}

const ButtonIcon = ({
  icon,
  type = 'primary',
  size = 'L',
  active,
  disabled,
  className,
  onClick,
}: IButtonIcon) => {
  return (
    <button
      onClick={onClick}
      className={classnames(`${className} justify-center rounded-full`, {
        'h-8 w-8': size === 'S',
        'h-10 w-10': size === 'M',
        'h-12 w-12': size === 'L',
        'bg-main-blue hover:bg-white': type === 'primary',
        'bg-white hover:bg-transparent hover:text-white hover:shadow-border': type === 'secondary',
        'text-main-blue hover:text-white': type === 'text',
        'bg-red hover:bg-white': type === 'remove',
        'bg-white text-white hover:bg-opacity-10 ': type === 'alternative',
        'bg-opacity-20': type === 'alternative' && !active,
        'pointer-events-none opacity-50': disabled,
        'bg-yellow': active,
      })}>
      <span className={`icon-${icon} text-lg`}></span>
    </button>
  )
}

export default ButtonIcon
